import '.ag{position:relative;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.dz{flex:1 1 auto;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.af{align-items:stretch;}.ssr-plugin'
import '.a3{justify-content:center;}.ssr-plugin'
import '.cl{font-size:1.125rem;}.ssr-plugin'
import '.g1{appearance:none;}.ssr-plugin'
import '.g2{height:2.75rem;}.ssr-plugin'
import '.g3{padding:0.5rem 3rem 0.5rem 1rem;}.ssr-plugin'
import '.eb{text-overflow:ellipsis;}.ssr-plugin'
import '.ck{border-radius:0.75rem;}.ssr-plugin'
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons'
import { FocusEventHandler } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Style, styled } from 'inlines'
import { InputField } from '../InputField'

export type SelectProps<T extends string | number> = {
  label?: string
  labelStyle?: Style
  containerStyle?: Style
  value?: T | null
  setValue: (value: T | null) => void
  options: { value: T; label: string }[]
  notSelectedLabel?: string
  variant?: 'outlined' | 'muted-blue'
  errorMessage?: string
  onBlur?: FocusEventHandler<HTMLSelectElement>
}

export const NOT_SELECTED_KEY = 'not-selelcted'

export const Select = <T extends string | number>({
  value,
  label,
  labelStyle,
  containerStyle,
  options,
  notSelectedLabel,
  variant = 'outlined',
  setValue,
  errorMessage,
  onBlur,
}: SelectProps<T>) => {
  const hasError = !!errorMessage
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const raw = e.target.value
    if (raw === NOT_SELECTED_KEY) {
      setValue(null)
      return
    }
    const match = options.find((o) => String(o.value) === raw)
    setValue(match ? match.value : null)
  }

  return (
    <InputField
      label={label}
      labelStyle={labelStyle}
      errorMessage={errorMessage}
      style={containerStyle}
    >
      <div className="ag d dz e af a3"
      >
        <styled.select className="cl g1 g2 g3 eb ck"
          value={
            value !== null && value !== undefined
              ? String(value)
              : NOT_SELECTED_KEY
          }
          onChange={handleChange}
          style={{
            border: `1px solid ${hasError ? 'var(--brand-primary)' : variant === 'outlined' ? 'var(--palette-blue-300)' : 'var(--palette-blue-50)'}`,
            background: hasError
              ? 'var(--status-error-muted)'
              : variant === 'outlined'
                ? 'var(--palette-white)'
                : 'var(--palette-blue-50)',
            '&:focus': {
              outline: 'none',
            },
            color:
              value !== null && value !== undefined
                ? 'var(--brand-secondary)'
                : 'var(--gray-300)',
          }}
          onBlur={onBlur}
        >
          {notSelectedLabel && (
            <styled.option value={NOT_SELECTED_KEY}>
              {notSelectedLabel}
            </styled.option>
          )}
          {options.map((option) => (
            <styled.option
              key={option.value ?? NOT_SELECTED_KEY}
              value={String(option.value)}
            >
              {option.label}
            </styled.option>
          ))}
        </styled.select>
        <FontAwesomeIcon
          icon={faChevronDown}
          color={
            variant === 'outlined'
              ? 'var(--palette-blue-200)'
              : 'var(--brand-secondary)'
          }
          style={{ position: 'absolute', right: '1rem' }}
        />
      </div>
    </InputField>
  )
}
